import { Box, Skeleton } from "@mui/material";

const ROWS = 5;

const SkeletonLoading = () => {
  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        borderRadius: 2,
        bgcolor: "#fff",
        boxShadow: 1,
      }}
    >
      {/* Header row */}
      <Skeleton
        variant="rectangular"
        height={28}
        width="100%"
        animation="wave"
        sx={{ mb: 2, borderRadius: 1 }}
      />

      {/* Body rows */}
      {Array.from({ length: ROWS }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          height={24}
          width="100%"
          animation="wave"
          sx={{
            mb: 1.5,
            borderRadius: 1,
          }}
        />
      ))}
    </Box>
  );
};

export default SkeletonLoading;
